import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetPolicyQuery } from "../../store/api/policyApi";
import { PolicyDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "policy";
export const PolicyDetailInitializer: React.FC = () => {
  const { org: orgName, policy: policyName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/policy/${policyName}`;

  const { data: policy, isLoading, isFetching, isError, error, refetch } = useGetPolicyQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!policy && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="policy" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !policy) {
    return <IncorrectItem kind="policy" canCreate={true} />;
  }

  return <PolicyDetailForm policy={policy} />;
};
